// extracted by mini-css-extract-plugin
export default {"reactions":"GWZpt","mobile":"kY017","android":"_4dutM","meeting":"cuaLa"};